import {
  AdminInput,
  Button,
  Modal,
  PropsModal,
  SuccessToast,
  updateBrandNotes,
  updateLocationNotes,
  reportError,
} from '@vgrubs/components';
import { Brand } from 'components/src/types/brand.types';
import { LocationEntity } from 'components/src/types/location.types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const BrandNoteModal = ({
  modalIsOpen,
  closeModal,
  setLoading,
  setData,
  data,
  pathPrefix,
}: PropsModal & {
  modalIsOpen: boolean;
  setData:
    | Dispatch<SetStateAction<Brand | null>>
    | Dispatch<SetStateAction<LocationEntity | null>>;
  data: Brand | LocationEntity | null;
  pathPrefix: 'locations' | 'brands';
}) => {
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (data?.notes) {
      setNotes(data.notes);
    }
  }, []);

  const updateFunction =
    pathPrefix === 'locations' ? updateLocationNotes : updateBrandNotes;

  async function handleNote() {
    if (!data) return;
    try {
      setLoading?.(true);
      const res = await updateFunction(data.id, notes);

      setData((prev) => {
        if (!prev) return prev;
        return { ...prev, notes };
      });

      SuccessToast(res.data.message);
      closeModal?.();
      setLoading?.(false);
    } catch (error) {
      reportError(error);
      setLoading?.(false);
    }
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header="Notes"
    >
      <AdminInput
        type="textarea"
        placeholder="Enter your notes here.."
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
      />

      <Button $selected $w="100%" $mt="40" onClick={() => handleNote()}>
        Save
      </Button>
    </Modal>
  );
};
